<div id="overlay">
  <div class="pop-up-container">
    <img
      class="popupimg"
      src="./assets/images/common/fc21_alert_box_gold.webp?t={{ version }}"
    />
    <img
      class="alert-img"
      [appImageSprite]="'fc21_alert_box_icon'"
      [params]="menu_icons"
      (click)="onAlertImageClick($event)"
    />

    <img
      class="closeiconImg"
      [appImageSprite]="'close'"
      [params]="menu_icons"
      (click)="onCloseClick($event)"
    />
    <div class="lang-specific-text-content">
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction"
        >{{ 'LANG00132' | translate }}!</span
      >
    </div>
  </div>
</div>
